import styles from 'css/src/components/share-video/RenderCompleteCelebration.module.scss';

import React from 'react';

const CONFETTI_COLORS = ['primary', 'accent', 'warning', 'success'] as const;
const CONFETTI_PIECES = 14;

const CONFETTI_COLOR_CLASSES: Record<(typeof CONFETTI_COLORS)[number], string> = {
    primary: styles['confetti--primary'],
    accent: styles['confetti--accent'],
    warning: styles['confetti--warning'],
    success: styles['confetti--success'],
};

// Pieces fan out evenly with a little variation in reach, so the burst reads as round but
// not mechanical.
const confettiPieces = Array.from({ length: CONFETTI_PIECES }, (_, index) => ({
    angle: (360 / CONFETTI_PIECES) * index,
    distance: 70 + ((index * 37) % 40),
    colorClass: CONFETTI_COLOR_CLASSES[CONFETTI_COLORS[index % CONFETTI_COLORS.length]],
}));

/**
 * A one-off burst over the video preview when its render finishes: a check badge pops in, a
 * ring and a little confetti burst out, and the whole thing fades away on its own so it
 * never covers the video for long. Purely decorative; hidden under reduced motion.
 */
const RenderCompleteCelebration: React.FC = () => (
    <div className={styles['celebration']} aria-hidden>
        <div className={styles['ring']} />
        {confettiPieces.map(({ angle, distance, colorClass }) => (
            <span
                key={angle}
                className={`${styles['confetti']} ${colorClass}`}
                style={
                    {
                        '--confetti-angle': `${angle}deg`,
                        '--confetti-distance': `${distance}px`,
                    } as React.CSSProperties
                }
            />
        ))}
        <div className={styles['badge']}>
            <svg viewBox="0 0 24 24" className={styles['check']}>
                <path d="M5 12.5l4.5 4.5L19 7.5" />
            </svg>
        </div>
    </div>
);

export default RenderCompleteCelebration;
